import React, {Suspense} from 'react';
import {Spin, Alert} from 'antd';

// Import panel components
import IssueForm, {IssueFormActions} from '../panels/IssueForm';
import ImpactAssessment from '../panels/ImpactAssessment';
import IssueActivity from '../panels/IssueActivity';
import LinkedPlans from '../panels/LinkedPlans';
import LinkedRisks from '../panels/LinkedRisks';
import IssueApproval from '../panels/IssueApproval';

interface IssueDetailContentProps {
  issueId?: string;
  issueCorrelative?: number;
  activePanel: string;
  onRegisterActions?: (actions: IssueFormActions) => void;
  onSavingChange?: (saving: boolean) => void;
}

const IssueDetailNavigation: React.FC<IssueDetailContentProps> = ({
                                                                    issueId,
                                                                    issueCorrelative,
                                                                    activePanel,
                                                                    onRegisterActions,
                                                                    onSavingChange
                                                                  }) => {
  const renderPanelContent = () => {
    const commonProps = {
      issueId,
      activePanel
    };

    switch (activePanel) {
      case 'issue-form':
        return (
          <IssueForm
            {...commonProps}
            onRegisterActions={onRegisterActions}
            onSavingChange={onSavingChange}
          />
        );
      case 'issue-approval':
        return <IssueApproval {...commonProps}/>;
      case 'issue-impact-assessment':
        return (
          <ImpactAssessment
            {...commonProps}
            issueCorrelative={issueCorrelative}
            onRegisterActions={onRegisterActions}
            onSavingChange={onSavingChange}
          />
        );
      case 'issue-monitoring':
        return <IssueActivity {...commonProps} />;
      case 'issue-linked-plans':
        return <LinkedPlans {...commonProps} />;
      case 'issue-linked-risks':
        return <LinkedRisks {...commonProps} />;
      default:
        return (
          <Alert
            message="Panel not found"
            description={`The requested panel "${activePanel}" could not be found.`}
            type="warning"
            showIcon
          />
        );
    }
  };

  return (
    <Suspense
      fallback={
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '400px'
        }}>
          <Spin size="large" tip="Loading panel..."/>
        </div>
      }
    >
      {renderPanelContent()}
    </Suspense>
  );
};

export default IssueDetailNavigation;
